<template>
  <div>
    <v-tooltip
      :color="color ? `#${color}` : 'grey'"
      :content-class="`${getContrastColor(color ? `#${color}` : '#666666', true, 135)}--text`"
      right
    >
      <template #activator="{on}">
        <v-avatar
          :class="`${getContrastColor(color ? `#${color}` : '#666666', true, 135)}--text`"
          :color="color ? `#${color}` : 'grey'"
          class="font-weight-bold rounded"
          size="24"
          style="font-size: 0.65rem"
          tile
          v-on="on"
        >
          {{ shortName }}
        </v-avatar>
      </template>

      <span>{{ fullName?.toLocaleUpperCase($i18n.locale) }}</span>
    </v-tooltip>
  </div>
</template>

<script>

import {getContrastColor} from '@/lib/color/index.js'

export default {
  name      : 'UserChip',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    fullName: {
      type   : String,
      default: ''
    },

    shortName: {
      type   : String,
      default: ''
    },

    color: {
      type   : String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {getContrastColor}
}
</script>

<style scoped>

</style>
